const promises = {};
export default function loadScript(src) {
    if (promises[src]) {
        return promises[src];
    }
    promises[src] = new Promise((resolve, reject) => {
        try {
            const script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', () => {
                resolve(script);
            });
            script.addEventListener('error', () => {
                reject(new Error(`Failed to load script: ${src}`));
            });
            document.head.appendChild(script);
        }
        catch (error) {
            reject(error);
        }
    });
    return promises[src];
}
//# sourceMappingURL=loadScript.js.map